import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import _ from 'lodash';

import {
  AddressItem,
} from '@/components';

export default {
  name: 'RegionPicker',
  components: {
    [AddressItem.name]: AddressItem,
  },
  props: {},
  data: () => ({
    isOpen: false,
    search: '',
    searchWatch: '',
    cityId: '',
    citiesFiltered: [],
  }),
  computed: {
    ...mapGetters('appointment', {
      addresses: 'getAddresses',
      serviceType: 'getServiceType',
      vehiculeType: 'getVehiculeType',
      customerDataRaw: 'getCustomerDataRaw',
      licenseplate: 'getLicensePlate',
      personalData: 'getPersonalData',
      addressId: 'getAddressId',
      company: 'getCompany',
      regionData: 'getRegionData',
      regionCode: 'getRegionCode',
    }),
    ...mapGetters('garage', {
      garages: 'getGarages',
      garageSearchResults: 'getGarageSearchResults',
    }),
    disableServiceCenterPicker() {
      return true;
    },
    isLeaseOrFleet() {
      return this.vehiculeType === 'lease' || this.vehiculeType === 'fleet';
    },
    isNewCustomer() {
      return this.customerDataRaw.customerType === 'unknown';
    },
    showWrongDepotMessage() {
      return false;
    },
    showErrorAddresses() {
      return this.customerDataRaw.addresses.length <= 0;
    },
    depot() {
      if (this.regionData.zipCode !== '' && this.regionData.city) {
        const depot = {
          id: `${this.regionCode} - ${this.regionData.city}`,
          postalCode: this.regionData.zipCode,
          address: this.regionData.address,
          city: this.regionData.city,
        };
        return depot;
      }

      const depot = null;
      return depot;
    },
  },
  methods: {
    ...mapActions('garage', {
      searchGarages: 'SEARCH_GARAGES',
    }),
    ...mapMutations('appointment', {
      setAddressMution: 'SET_ADDRESS',
    }),
    openPopup() {
      if (!this.disableServiceCenterPicker) {
        this.isOpen = true;
        document.getElementById('app').style.overflow = 'hidden';
      }
    },
    closePopup() {
      this.isOpen = false;
      this.searchWatch = '';
      document.getElementById('app').style.overflow = 'unset';
    },
    ...mapActions('garage', {
      getGarages: 'SEARCH_GARAGES',
    }),
    setServiceCenter() {
      this.closePopup();
    },
    searchList: _.debounce(function () {
      this.search = this.searchWatch;
      this.setCities();
    }, 350),
    setCities() {
      if (this.search.length > 1) {
        const searchLowerCase = this.search.toLowerCase();
        this.citiesFiltered = this.customerDataRaw.addresses.filter(c => c.address.toLowerCase().startsWith(searchLowerCase) || c.postalCode.toString().startsWith(searchLowerCase));
      } else {
        this.citiesFiltered = [];
      }
    },
    searchCityKeybordEvents(e) {
      const elements = document.getElementsByClassName('a-search-button__result');
      if ((e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 13) || elements.length === 0) {
        return;
      }

      // Enter
      if (e.keyCode === 13) {
        const highlightElements = document.getElementsByClassName('highlight');
        if (highlightElements.length > 0) {
          this.cityId = highlightElements[0].getAttribute('data-id');
          const city = highlightElements[0].getAttribute('data-city');
          const zipCode = highlightElements[0].getAttribute('data-zip-code');
          const label = `${city} - ${zipCode}`;
          this.searchCompAddress(this.cityId, label);
        }
        return;
      }

      // Set current index
      let currentHighlightIndex = -1;
      for (let index = 0; index < elements.length; index += 1) {
        if (elements[index].classList.contains('highlight')) {
          currentHighlightIndex = index;
        }
      }

      // Clear all highlights
      for (let index = 0; index < elements.length; index += 1) {
        elements[index].classList.remove('highlight');
      }

      // Keydown
      if (e.keyCode === 40) {
        if (elements.length > currentHighlightIndex + 1) {
          elements[currentHighlightIndex + 1].classList.add('highlight');
        }
      }

      // Keyup
      if (e.keyCode === 38) {
        if (currentHighlightIndex > 0) {
          elements[currentHighlightIndex - 1].classList.add('highlight');
        }
        if (currentHighlightIndex === 0) {
          elements[0].classList.add('highlight');
        }
      }

      // Scrolltop
      const highlightElements = document.getElementsByClassName('highlight');
      if (highlightElements.length > 0) {
        const topPos = highlightElements[0].offsetTop;
        document.getElementsByClassName('a-search-button__results-list')[0].scrollTop = topPos;
      }
    },
    searchCompAddress(id, label) {
      this.searchWatch = label;
      this.citiesFiltered = [];
      this.setAddressMution = id;
    },
  },
  watch: {
    searchWatch() {
      this.searchList();
    },
  },
  created() {
    if (this.garages.length === 0) {
      this.getGarages();
    }

    if (this.addresses.length > 0) {
      // console.log(this.garages);
      // console.log(this.addresses);
    }
    // if (this.cities.length === 0) {
    //   this.getCities();
    // }
  },
};
